import config from "../../config";
export default function Buttons() {
  return (
    <div className="button-container">
      <a href={config.partnerLink} rel="nofollow" className="main-button">
        Login {config.brandName}
      </a>
      <a href={config.app} rel="nofollow" className="main-button">
        Baixe App
      </a>
    </div>
  );
}
